import { equals } from "ramda";
import { useEffect, useState } from "react";

/**
 * Pass all data-* attributes
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDataAttributes = (props: any): Record<string, string> => {
  const [data, setData] = useState({});

  useEffect(() => {
    const dataAttributes: Record<string, string> = {};

    for (const key of Object.keys(props)) {
      if (key.startsWith("data-")) {
        const value = props[key];
        if (value != undefined) dataAttributes[key] = props[key];
      }
    }

    if (!equals(data, dataAttributes)) {
      setData(dataAttributes);
    }
  }, [data, props]);

  return data;
};
